import { gql } from "@apollo/client";

const ADD_LEAGUE_ROLE = gql`
  mutation createLeagueMemberRole(
    $role: Int!
    $user: Int
    $userPublicId: String
    $league: Int
    $leaguePublicId: String
    $leagueMember: Int!
  ) {
    createLeagueMemberRole(
      createLeagueMemberRoleInput: {
        role: $role
        user: $user
        userPublicId: $userPublicId
        league: $league
        leaguePublicId: $leaguePublicId
        leagueMember: $leagueMember
      }
    ) {
      id
    }
  }
`;

export default ADD_LEAGUE_ROLE;
